import { render } from "./MyProcessings.vue?vue&type=template&id=bbf96a8a&scoped=true"
import script from "./MyProcessings.vue?vue&type=script&lang=js"
export * from "./MyProcessings.vue?vue&type=script&lang=js"

import "./MyProcessings.vue?vue&type=style&index=0&id=bbf96a8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbf96a8a"]])

export default __exports__